"use client"
import { CurrencyLockup, CurrencyLockupAvatar } from "@opensea/app-kit"
import { FlexCenter, NumberDisplay } from "@opensea/ui-kit"
import { ArrowRightAlt } from "@opensea/ui-kit/icons"
import { bn } from "@opensea/utils"
import type { SwapQuote } from "../../flow/SideSheetFlows/SwapFlow/provider/SwapProvider"

type SwapRoute = NonNullable<SwapQuote>["swapRoutes"][number]

type SwapToastContentProps = {
  route: SwapRoute | null | undefined
}

export function SwapToastContent({ route }: SwapToastContentProps) {
  if (!route || route.__typename !== "SwapRoute") {
    return null
  }

  return (
    <FlexCenter className="gap-2 py-1 mt-1 whitespace-nowrap">
      <FlexCenter className="gap-1.5">
        {route.fromAsset.__typename === "Currency" ? (
          <CurrencyLockup currency={route.fromAsset}>
            <CurrencyLockupAvatar size={24} />
          </CurrencyLockup>
        ) : null}
        <NumberDisplay
          suffix={
            route.fromAsset.__typename === "Currency"
              ? route.fromAsset.symbol
              : ""
          }
          value={bn(
            route.fromQuantity,
            route.fromAsset.__typename === "Currency"
              ? route.fromAsset.decimals
              : 0,
          )}
        />
      </FlexCenter>
      <ArrowRightAlt size={20} />
      <FlexCenter className="gap-1.5">
        {route.toAsset.__typename === "Currency" ? (
          <CurrencyLockup currency={route.toAsset}>
            <CurrencyLockupAvatar size={24} />
          </CurrencyLockup>
        ) : null}
        <NumberDisplay
          suffix={
            route.toAsset.__typename === "Currency" ? route.toAsset.symbol : ""
          }
          value={bn(
            route.toQuantity,
            route.toAsset.__typename === "Currency"
              ? route.toAsset.decimals
              : 0,
          )}
        />
      </FlexCenter>
    </FlexCenter>
  )
}
